import styled from '@emotion/styled';
import { Editable } from 'slate-react';
import { colors } from 'theme/colors';
import Icon from '@mui/material/Icon';

interface StyledFieldProps {
  readOnly?: boolean;
}

export const StyledEditable = styled(Editable)<StyledFieldProps>(({ readOnly }) => ({
  borderRadius: 4,
  borderColor: colors.gray400,
  borderWidth: 1,
  borderStyle: 'solid',
  padding: '13px 8px',
  minHeight: '120px !important',
  wordBreak: 'break-word',
  ...(readOnly ? { backgroundColor: colors.gray100 } : {}),
  '&:focus': {
    outline: '2px solid #1976d2',
  },
  p: {
    margin: '1px 0',
    fontSize: 14,
    boxSizing: 'border-box',
    ...(readOnly ? { color: colors.gray400 } : {}),
  },
  li: {
    margin: '1px 0',
    listStyle: 'inside',
  },
  ol: {
    padding: 0,
    margin: 0,
    '& li': {
      listStyle: 'decimal',
      listStylePosition: 'inside',
    },
  },
}));

export const IconStyle = styled(Icon)(() => ({
  fontSize: '22px',
  verticalAlign: 'text-bottom',
}));

export const ButtonToolboxStyle = styled.span((props: any) => ({
  cursor: 'pointer',
  padding: '2px',
  margin: '2px',
  // eslint-disable-next-line no-nested-ternary
  color: props.reversed
    ? props.active
      ? colors.gray400
      : colors.gray300
    : props.active
      ? colors.white
      : colors.primary900,
  '&:hover': {
    color: colors.primary900,
  },
}));

export const StyledContainerEditorIcons = styled.span((props: any) => ({
  // eslint-disable-next-line no-nested-ternary
  background: props.reversed
    ? colors.gray200
    : props.active
      ? colors.primary900
      : colors.white,

  width: '32px',
  height: '32px',
  alignContent: 'center',
  borderRadius: '4px',
  border: `1px solid ${colors.primary50}`,

  '&:hover': {
    background: colors.primary25,
  },
  '&:pressed': {
    background: colors.primary100,
  },
}));
